import { Link } from '@tanstack/react-router';
import { CircleArrowLeft } from 'lucide-react';
import { useState } from 'react';

import { CreateHourlyTuitionForm } from '~features/payment/ui/hourly-tuition/create-hourly-tuition-form';
import { HourlyTuitionRateTable } from '~features/payment/ui/hourly-tuition/hourly-tuition-rate-table';

export const HourlyTuitionSettings = () => {
  const [isCreateHourlyTuitionFormOpen, setIsCreateHourlyTuitionFormOpen] =
    useState(false);

  return (
    <>
      <div className='mb-4 border-b pb-4'>
        <Link
          className='flex w-fit items-center gap-2'
          to='/payment/hourly-tuition'
        >
          <CircleArrowLeft className='size-6 text-custom-secondary-1' />
          <h2 className='text-2xl font-semibold text-custom-secondary-1'>
            Tuition Settings
          </h2>
        </Link>
      </div>

      <div className='mx-auto max-w-4xl space-y-6'>
        <div className='text-center'>
          <p className='text-[#6B7280]'>
            Configure hourly tuition rates and preferences
          </p>
        </div>

        <CreateHourlyTuitionForm
          open={isCreateHourlyTuitionFormOpen}
          onOpenChange={(open) => {
            setIsCreateHourlyTuitionFormOpen(open);
          }}
        />

        <HourlyTuitionRateTable />
      </div>
    </>
  );
};
